import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../SidebarItem";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {canAccessEnrichment} from "utils/enrichmentAccess";

import {SidebarContext} from "../../../../../SidebarContext";

RetailerEnrichmentItem.propTypes = {
    retailerId: PropTypes.string.isRequired
};

function RetailerEnrichmentItem({retailerId}) {
    const {currentPath, currentMemberAuthorizations, currentOrganization} = useContext(SidebarContext);

    if (!canAccessEnrichment(currentMemberAuthorizations, currentOrganization)) {
        return null;
    }

    return (
        <SidebarItem
            to={MarketplaceRoutes.RETAILER_ENRICHMENT(retailerId)}
            selected={currentPath.includes(MarketplaceRoutes.RETAILER_ENRICHMENT(retailerId))}
        >
            <FormattedMessage id='sidebar.item.enrichment' />
        </SidebarItem>
    );
}

export default RetailerEnrichmentItem;
